'use es6';

export default (({
  apiClient,
  type,
  surveyKey
}) => {
  return apiClient.get(`wootric/survey/find?key=${surveyKey}&type=${type}`);
});